module.exports = [{"id":"j84fhfs03","size":1,"name":"Sequence This!","created":"Septemeber 16th","description":"Nullam porttitor lacus at turpis. Donec posuere metus vitae ipsum. Aliquam non mauris.\n\nMorbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.","url":"genome.me","project":"1","tags":[{"id":24}]}]


//////////////////
// WEBPACK FOOTER
// ./src/LINK_DATA.json
// module id = 835
// module chunks = 0